const ELECTRIC_CAR_CATEGORIES = ['electric car', 'electric vehicles'];

export const TREEHOUSE_ARTICLE_ID = ['best-electric-cars'];

export function isEvArticle({ slug, categories }) {
  return (
    slug === 'electric-car' ||
    !!(categories && categories.some(category => ELECTRIC_CAR_CATEGORIES.includes(category.toLowerCase())))
  );
}
